// รูปโปรไฟล์พนักงาน — พนักงานหลายคนไม่มีรูปหรือลิงก์ 404 จึงต้องมีตัวอักษรสำรองเสมอ
import { useState } from "react";
import { cn } from "@shared/lib/utils";

export function PersonAvatar({
  url,
  initial,
  size,
}: {
  url?: string | null;
  initial: string;
  /** sm = แถวกะทัดรัดของรายชื่อคน — ขนาดที่ทั้งแผงผู้เข้าถึงและหน้า Staff ใช้ */
  size?: "sm";
}) {
  const [failed, setFailed] = useState(false);
  const showPhoto = !!url && !failed;
  // span ไม่ใช่ div เพราะแถวผลค้นหาเป็น <button> ซึ่งรับได้แค่ phrasing content
  // (ทุกที่ที่ใช้เป็น flex container อยู่แล้ว span จึงกลายเป็นบล็อกให้เอง)
  return (
    <span className={cn("avatar", size)}>
      {showPhoto && <img src={url} alt="" loading="lazy" onError={() => setFailed(true)} />}
      <span className="logo-fallback" style={showPhoto ? undefined : { display: "grid" }}>
        {initial}
      </span>
    </span>
  );
}
